//codex-- Use the existing authenticated settings endpoint with an explicit cookie contract.
import axios from 'axios';

//codex-- Keep these values aligned with the PHP allowlist and the existing scheduler filter.
export const SCHEDULER_DEPARTMENTS = ['Field', 'Service', 'Maintenance', 'Install', 'Admin', 'Purchasing'];
export const normalizeSchedulerDepartment = (value) =>
  value === '' || SCHEDULER_DEPARTMENTS.includes(value) ? value : 'Field';

//codex-- An absent or unrecognized stored department falls back to Field.
export async function getFullSchedulerDefault(apiUrl) {
  const response = await axios.get(`${apiUrl}/config_system_crud.php`, {
    params: { getFullScheduler: true },
    withCredentials: true,
  });
  if (response.data?.success !== true) throw new Error('Could not load your default department.');
  return normalizeSchedulerDepartment(response.data.default_department);
}

//codex-- Employee ownership comes from the session, never from this payload.
export async function saveFullSchedulerDefault(apiUrl, department) {
  const response = await axios.post(`${apiUrl}/config_system_crud.php`, {
    status: 'saveFullScheduler',
    data: { default_department: department },
  }, { withCredentials: true, headers: { 'Content-Type': 'application/json' } });
  if (response.data?.success !== true) throw new Error('Could not save your default department.');
  return normalizeSchedulerDepartment(response.data.default_department);
}
